<template>
  <div class="md-layout stats-layout">
    <div
      v-for="cnt in countBar"
      v-bind:key="cnt.tag"
      class="md-layout-item md-xlarge-size-10 md-large-size-15 md-medium-size-20 md-small-size-33 md-xsmall-size-50"
    >
      <h3 class="title stats-title">{{cnt.count}}</h3>
      <h6>{{cnt.tag}}</h6>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      countBar: []
    };
  },

  watch: {
    settings: function(payload, oldPayload) {
      this.countBar = this.statsCount(this.settings);
    }
  },

  methods: {
    statsCount(data) {
      let array_elements = data.slice();
      array_elements.sort();

      var ret = [];
      var current = null;
      var cnt = 0;
      for (var i = 0; i < array_elements.length; i++) {
        if (array_elements[i] != current) {
          if (cnt > 0) {
            ret.push({
              tag: current,
              count: cnt
            });
          }
          current = array_elements[i];
          cnt = 1;
        } else {
          cnt++;
        }
      }
      if (cnt > 0) {
        ret.push({
          tag: current,
          count: cnt
        });
      }

      ret.sort((a, b) =>
        a.count > b.count
          ? 1
          : a.count === b.count
          ? a.tag < b.tag
            ? 1
            : -1
          : -1
      );

      return ret;
    }
  }
};
</script>

<style scoped>
.stats-layout {
  justify-content: center;
  text-align: center;
}

.stats-title {
  margin-top: -20px;
}
</style>
